/* Blue Collar Apparel v3 — interacciones (vanilla, sin librerías) */
(function () {
  "use strict";

  /* Altura real de la cabecera → variable CSS para los elementos sticky */
  function initHeaderHeight() {
    var header = document.querySelector(".section-header");
    if (!header) return;
    var set = function () {
      document.documentElement.style.setProperty("--bc-header-h", Math.round(header.getBoundingClientRect().height) + "px");
    };
    set();
    window.addEventListener("resize", set);
  }

  /* ===== Ficha de producto: variantes + galería ===== */
  function initProduct() {
    var root = document.querySelector("[data-bc-product]");
    if (!root) return;

    var dataEl = root.querySelector("[data-bc-variants]");
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var priceEl = root.querySelector("[data-bc-price]");
    var compareEl = root.querySelector("[data-bc-compare]");
    var idInput = root.querySelector('input[name="id"]');
    var atc = root.querySelector("[data-bc-atc]");
    var labelAdd = atc ? atc.getAttribute("data-label-add") : "";
    var labelSold = atc ? atc.getAttribute("data-label-soldout") : "";
    var groups = Array.prototype.slice.call(root.querySelectorAll("[data-bc-option]"));
    var money = function (cents) { return "$" + (cents / 100).toFixed(2); };

    function selected() {
      return groups.map(function (g) {
        var a = g.querySelector(".bc-pill.bc-active");
        return a ? a.getAttribute("data-value") : null;
      });
    }
    function find(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    /* Tacha las opciones que, combinadas con lo ya elegido, no tienen stock */
    function refreshAvailability() {
      var opts = selected();
      groups.forEach(function (g, gi) {
        g.querySelectorAll(".bc-pill").forEach(function (p) {
          var test = opts.slice();
          test[gi] = p.getAttribute("data-value");
          var v = find(test);
          p.classList.toggle("bc-oos", !v || !v.available);
        });
      });
    }
    function update() {
      refreshAvailability();
      groups.forEach(function (g) {
        var label = g.parentElement.querySelector("[data-bc-selected]");
        var a = g.querySelector(".bc-pill.bc-active");
        if (label && a) label.textContent = a.getAttribute("data-value");
      });
      var v = find(selected());
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (atc && !atc.hasAttribute("data-coming")) {
        atc.disabled = !v.available;
        atc.textContent = v.available ? labelAdd : labelSold;
      }
      if (v.featured_image) goToImage(v.featured_image);
    }
    groups.forEach(function (g) {
      g.querySelectorAll(".bc-pill").forEach(function (p) {
        p.addEventListener("click", function () {
          g.querySelectorAll(".bc-pill").forEach(function (x) { x.classList.remove("bc-active"); });
          p.classList.add("bc-active");
          update();
        });
      });
    });

    /* Galería: en escritorio, columna de fotos con miniaturas; en móvil, carrusel */
    var gallery = root.querySelector("[data-bc-gallery]");
    var slides = gallery ? Array.prototype.slice.call(gallery.querySelectorAll("[data-bc-slide]")) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll("[data-bc-thumb]"));
    var counter = root.querySelector("[data-bc-counter]");
    var isDesktop = function () { return window.matchMedia("(min-width: 990px)").matches; };
    var headerOffset = function () {
      var h = document.querySelector(".section-header");
      return (h ? h.getBoundingClientRect().height : 64) + 12;
    };
    function setActive(i) {
      thumbs.forEach(function (t, j) { t.classList.toggle("bc-active", j === i); });
      if (counter) counter.textContent = (i + 1) + " / " + slides.length;
    }
    function goTo(i) {
      var s = slides[i];
      if (!s) return;
      if (isDesktop()) {
        var y = s.getBoundingClientRect().top + window.scrollY - headerOffset();
        window.scrollTo({ top: y, behavior: "smooth" });
      } else {
        gallery.scrollTo({ left: s.offsetLeft - gallery.offsetLeft, behavior: "smooth" });
      }
    }
    function goToImage(src) {
      var key = src.split("?")[0];
      var i = slides.findIndex(function (s) { return (s.getAttribute("data-src") || "").split("?")[0] === key; });
      if (i >= 0) goTo(i);
    }
    thumbs.forEach(function (t, i) { t.addEventListener("click", function () { goTo(i); }); });
    if (slides.length && "IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) setActive(slides.indexOf(e.target)); });
      }, { threshold: 0.6 });
      slides.forEach(function (s) { io.observe(s); });
    }
    setActive(0);

    /* Al cargar no saltamos a la foto de la variante: se queda arriba */
    var firstUpdate = true;
    var origGoToImage = goToImage;
    goToImage = function (src) { if (firstUpdate) return; origGoToImage(src); };
    update();
    firstUpdate = false;
  }

  document.addEventListener("DOMContentLoaded", function () {
    initHeaderHeight();
    initProduct();
  });
})();
